<script lang="ts">
	import Toast from './Toast.svelte';
	import { toast } from '../stores/toast';

	let toasts = $state<any[]>([]);

	// Subscribe to toast store
	$effect(() => {
		const unsubscribe = toast.subscribe((value) => {
			toasts = value;
		});

		return unsubscribe;
	});
</script>

<!-- Container for all toast notifications -->
<div class="toast-container">
	{#each toasts as toastNotification (toastNotification.id)}
		<Toast
			message={toastNotification.message}
			type={toastNotification.type}
			details={toastNotification.details}
			duration={toastNotification.duration}
			dismissible={toastNotification.dismissible}
			onDismiss={() => toast.dismiss(toastNotification.id)}
		/>
	{/each}
</div>

<style>
	.toast-container {
		position: fixed;
		top: 20px;
		right: 20px;
		z-index: 1000;
		pointer-events: none;
	}

	.toast-container :global(.toast) {
		pointer-events: auto;
		margin-bottom: 12px;
	}
</style>